<div class="payment-history">

  <!-- Loading Spinner -->
  @if (isLoading) {
    <mat-progress-spinner
      mode="indeterminate"
      diameter="40">
    </mat-progress-spinner>
  }

  <!-- Error Message -->
  @if (!isLoading && error) {
    <div class="error-message">
      <mat-icon color="warn">error</mat-icon>
      <span>{{ error }}</span>
    </div>
  }

  <!-- Content -->
  @if (!isLoading && !error) {
    <!-- If there are payments -->
    @if (paymentGroups().length) {
      <h3 class="section-title">History</h3>
      <table mat-table #table="matTable" [dataSource]="dataSource" multiTemplateDataRows>
        <!-- Expand/Collapse Column -->
        <ng-container matColumnDef="expand">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let group">
            @if (group[0]?.details?.length) {
              <button
                mat-icon-button
    (click)="       $event.stopPropagation();
       toggleRow(group[0].transactionReferenceNo ?? 0)
     ">
                <!-- <mat-icon [class.expanded]="isExpanded(group[0].transactionReferenceNo ?? 0)">
                chevron_right
              </mat-icon> -->
            </button>
          }
        </td>
      </ng-container>
      <!-- Date Paid Column -->
      <ng-container matColumnDef="datePaid">
        <th mat-header-cell *matHeaderCellDef>Date</th>
        <td mat-cell *matCellDef="let group">
          {{ group[0].datePaid | date: getDateFormat() }}
        </td>
      </ng-container>
      <!-- Type Column -->
      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef>Type</th>
        <td mat-cell *matCellDef="let group">
          {{ group[0].type }}
        </td>
      </ng-container>
      <!-- Amount Column -->
      <ng-container matColumnDef="amount">
        <th mat-header-cell *matHeaderCellDef class="align-right">Amount</th>
        <td mat-cell *matCellDef="let group" class="align-right">
          {{ getGroupAmount(group) | price }}
        </td>
      </ng-container>
      <!-- Method Column -->
      <!-- <ng-container matColumnDef="method">
      <th mat-header-cell *matHeaderCellDef>Method</th>
      <td mat-cell *matCellDef="let group">{{ group[0].paymentMethod }}</td>
    </ng-container> -->
    <!-- Expanded Detail Row -->
    <!-- Expanded Detail Row -->
    <ng-container matColumnDef="expandedDetail">
      <th mat-header-cell *matHeaderCellDef></th>        <!-- ← this -->
      <td mat-cell *matCellDef="let group"
        [attr.colspan]="displayedColumns().length">
        @if (isExpanded(group[0].transactionReferenceNo ?? 0)) {
          <div class="detail-container">
            <table class="detail-table">
              @for (d of group[0].details; track d) {
                <tr>
                  <td>{{ d.type }}</td>
                  <td class="align-right">{{ d.paymentAmount | price }}</td>
                  <!-- <td>{{ d.paymentMethod }}</td> -->
                </tr>
              }
            </table>
          </div>
        }
      </td>
    </ng-container>
    <!-- Header Row -->
    <tr mat-header-row *matHeaderRowDef="displayedColumns()"></tr>
    <!-- Summary Row -->
    <tr
      mat-row
      *matRowDef="let row; columns: displayedColumns()"
      class="summary-row"
      [class.error-row]="row[0].nsfPayment"
      style="cursor: pointer;">
    </tr>
    <!-- Detail Row -->
    <tr
      mat-row
      *matRowDef="let row; columns: ['expandedDetail']; when: isDetailRow"
      class="detail-row">
    </tr>
  </table>
} @else {
  <div class="no-data">
    <mat-icon>info</mat-icon>
    <span>No data available</span>
  </div>
}
<!-- No Data Template -->
}
</div>